export default __webpack_public_path__ + "static/HeroImage-e1213a9a0db756ae4d5778e6597cee08.jpg";